module.exports = __webpack_public_path__ + "static/media/carousel-img1.ecd5eb9b.png";